import {Component , OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {FormControl , FormGroup} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {CheckModalComponent} from '../../check-save-modal/check-modal';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {BlogService} from '../../../../core/services/blog.service';
import moment from 'moment';
import {TargetGroupService} from '../../../../core/services/targetGroup.service';
import {ToastrService } from 'ngx-toastr';
import {FrontUserService} from '../../../../core/services/frontUsers.service';
import {BlogTypeService} from '../../../../core/services/blogType.service';
import {PlatformsService} from '../../../../core/services/platforms.service';
import {FuseConfigService} from '../../../../core/services/config.service';

@Component({
    selector: 'blog-news',
    templateUrl: './blog-new.html',
    styleUrls: ['./blog-new.scss', './../custom-blog/new-blog.component.scss'],
    standalone: false
})

export class BlogNewComponent implements OnInit {
  public editorConfig = {
    placeholder: ''
  };
  public info = {
    title: '' ,
    text: '' ,
    link: '' ,
    linkLabel: '' ,
    image: '' ,
    video: '' ,
    header: '' ,
    fullText: '' ,
    fullTitle: '' ,
    dateFrom: '' ,
    dateTo: '' ,
    type: '' ,
    date: 0 ,
    blogTypeId: ''
  };
  public opacityColor;
  public videoUrl;
  public blogForm: FormGroup = new FormGroup({
    title: new FormControl('') ,
    fullTitle: new FormControl('') ,
    text: new FormControl('') ,
    fullText: new FormControl('') ,
    link: new FormControl('') ,
    linkLabel: new FormControl('') ,
    image: new FormControl('') ,
    video: new FormControl('') ,
    header: new FormControl('') ,
    dateFrom: new FormControl('') ,
    dateTo: new FormControl('') ,
    type: new FormControl('custom') ,
    visible: new FormControl('') ,
    targetGroup: new FormControl('') ,
    userRole: new FormControl('') ,
    tag: new FormControl('') ,
    blogTypeId: new FormControl(''),
    lang: new FormControl('de')
  });

  platforms;
  selectedPlatforms = [];

  public uploadedImg = null;
  public uploadedImg2 = null;
  public radio = 'small';
  public formWasChanged = false;
  public returnBack;
  category = [];
  public targetGroups = [];
  frontRoles = [];
  tags = [];
  public config = {
    editable: true ,
    spellcheck: true ,
    height: 'auto' ,
    minHeight: '150px' ,
    width: 'auto' ,
    minWidth: '0' ,
    translate: 'yes' ,
    enableToolbar: true ,
    showToolbar: true ,
    placeholder: 'Enter text here...' ,
    imageEndPoint: '' ,
    toolbar: [
      [ 'bold' , 'italic' , 'underline' , 'strikeThrough' , 'superscript' , 'subscript' ] ,
      [ 'fontSize' ] ,
      [ 'justifyLeft' , 'justifyCenter' , 'justifyRight' , 'justifyFull' , 'indent' , 'outdent' ] ,
      [ 'delete' , 'removeFormat' ] ,
      [ 'paragraph' , 'blockquote' , 'removeBlockquote' , 'horizontalLine' , 'orderedList' , 'unorderedList' ]
    ]
  };
  array;
  public subscription = new Subscription();

  constructor (private _sanitizer: DomSanitizer , public dialog: MatDialog , public router: Router ,
               public snackBar: MatSnackBar , public blogService: BlogService ,
               public targetService: TargetGroupService , public toastr: ToastrService  ,
               public frontUser: FrontUserService , public blogType: BlogTypeService,
               private platformsService: PlatformsService, private fuseConfig: FuseConfigService) {
  }

  ngOnInit () {
    this.getTargetGroups();
    this.getUserRole();
    this.getTags();
    this.getBlogType();
    this.info.date = moment().valueOf();
    this.blogForm.valueChanges.subscribe(data => {
      this.formWasChanged = true;
      if (!data.image && this.uploadedImg) {
        delete data.image;
      }
      this.info = Object.assign({} , this.info , data);
      if (this.info.video) {
        if (this.info.video.indexOf('embed') !== -1) {
          this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
            this.info.video
          );
        } else {
          this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
            this.parseYoutube(this.info.video)
          );
        }
      } else {
        this.videoUrl = '';
      }
    });
    this.opacityColor = this.hexToRGB('#FFFFFF' , 0.3);
    this.fuseConfig.organizationId.subscribe((res) => {
      if (res) {
        let organizationId = parseInt(res, 10);
        this.platformsService.getByOrganizationId(organizationId).subscribe(platforms => {
          this.platforms = platforms;
          if (this.platforms && this.platforms.length === 1) {
            this.changePlatforms({value: [this.platforms[0].id]});
          }
        });
      }
    });
    this.subscription.add(this.fuseConfig.role.subscribe(res => {
      if (res && res === 'superAdmin') {
        this.getPlatforms();
      }
    }));
  }

  getPlatforms() {
    this.platformsService.getPlatforms().subscribe((res: any) => {
      if (res && res.length) {
        this.platforms = res;
        if (this.platforms && this.platforms.length === 1) {
          this.changePlatforms({value: [this.platforms[0].id]});
        }
      }
    });
  }

  changePlatforms(platform) {
    this.selectedPlatforms = platform.value;
  }

  getUserRole () {
    this.frontUser.getRoles().subscribe((data: any) => {
      this.frontRoles = data;
    });
  }

  getTags () {
    this.frontUser.listTags().subscribe((data: any) => {
      this.tags = data;
    });
  }

  getTargetGroups () {
    this.targetService.targetGroupsGroped().subscribe((data: any) => {
      this.targetGroups = data.targetGroups;
    });
  }

  getBlogType () {
    this.blogType.getBlogTypeDropDown().subscribe((data: any) => {
      this.category = data;
    });
  }

  hexToRGB (hex , alpha) {
    const r = parseInt(hex.slice(1 , 3) , 16) ,
      g = parseInt(hex.slice(3 , 5) , 16) ,
      b = parseInt(hex.slice(5 , 7) , 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }

  setImg (img) {
    this.uploadedImg = img;
    this.uploadedImg2 = img;
    const reader = new FileReader();
    const that = this;
    reader.onload = function (e) {
      const res: any = e;
      that.info.image = res.target.result;
    };
    reader.readAsDataURL(this.uploadedImg);
  }

  selectBlog (e) {
    this.radio = e;
  }

  canDeactivate (): Observable<boolean> | boolean {
    return this.goBack();
  }

  goBack () {
    let dialogRef;
    if (this.formWasChanged && !this.returnBack) {
      dialogRef = this.dialog.open(CheckModalComponent , {
        panelClass: 'unsave-form-dialog' ,
        width: '400px' ,
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.blogForm.valid) {
            // this.addEvent(false);
            return true;
          } else {
            this.snackBar.open('Please fill forms correctly' , '' , {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  addBlog (returnToBlog) {
    const data = this.blogForm.value;
    if (data.visible === 'public') {
      delete data.targetGroup;
    }
    if (this.selectedPlatforms && this.selectedPlatforms.length) {
      let platforms = this.selectedPlatforms.map(el => '/' + el.toString() + '/');
      data.platforms = platforms;
    }
    data.file = this.uploadedImg2;
    this.blogService.addBlog(data).subscribe((res) => {
      if (res) {
        this.toastr.success('Blog added' , 'Success!');
        // this.cantonService.addSuccess = true;
        this.returnBack = returnToBlog;
        this.router.navigate([ './pages/blog' ]);
      }
    });
  }

  // https://www.youtube.com/watch?v=4fkfyKg001g
  parseYoutube (url) {
    let link = 'https://www.youtube.com/embed/';
    const videoId = url.split('?v=');
    link = link + videoId[ 1 ];
    return link;
  }

  closePicker(event, data) {
    let res = data.datepickerInput.value;
    if (res) {
      if (event === 'dateFrom') {
        this.blogForm.patchValue({dateFrom: moment(res).format('DD.MM.YYYY')});
      }
      if (event === 'dateTo') {
        this.blogForm.patchValue({dateTo: moment(res).format('DD.MM.YYYY')});
      }
    }
  }

  setAll (name , i) {
    console.log(name);
    this.array = (this.blogForm.get('targetGroup').value && this.blogForm.get('targetGroup').value.length) ? this.blogForm.get('targetGroup').value : [];
    console.log(this.array , 'aard');
    for (let i = 0; i < this.targetGroups.length; i++) {
      console.log(this.targetGroups[ i ].name);
      if (this.targetGroups[ i ].name === name) {
        console.log(true);
        let arr = [];
        let arrForPush = [];
        arr = (this.blogForm.get('targetGroup').value && this.blogForm.get('targetGroup').value.length) ? this.blogForm.get('targetGroup').value : [];
        let count = 0;
        for (let j = 0; j < this.targetGroups[ i ].data.length; j++) {
          console.log(this.targetGroups[ i ].data[ j ]);
          let index = this.array.indexOf(this.targetGroups[ i ].data[ j ].id);
          if (index !== -1) {
            arr.splice(index , 1);
            count++;
            arrForPush.push(this.targetGroups[ i ].data[ j ].id);
          } else {
            arr.push(this.targetGroups[ i ].data[ j ].id);
          }
        }
        if (count === this.targetGroups[ i ].data.length) {
          this.array = Array.from(arr);
        } else {
          arrForPush.forEach((item) => {
            arr.push(item);
          });
          this.array = Array.from(arr);
        }
      }
    }
    if (this.targetGroups[ i ].data && this.targetGroups[ i ].data[ 0 ] && this.array.includes(this.targetGroups[ i ].data[ 0 ].id)) {
      this.targetGroups[ i ].selected = true;
    } else {
      this.targetGroups[ i ].selected = false;
    }
    console.log(this.array , 'aard');
    this.blogForm.patchValue({targetGroup: this.array});
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
